// ── Pillar constants ─────────────────────────────

export const PILLAR_TYPES = [
  'e_marketplaces',
  'standalone_websites',
  'social_media',
  'apps',
  'account_management',
  'meeting',
  'research_survey',
  'training',
] as const

export type PillarType = (typeof PILLAR_TYPES)[number]

export const PILLAR_LABELS: Record<PillarType, string> = {
  e_marketplaces: 'E-Marketplaces',
  standalone_websites: 'Standalone Websites',
  social_media: 'Social Media',
  apps: 'Apps',
  account_management: 'Account Management',
  meeting: 'Meeting',
  research_survey: 'Research/Survey',
  training: 'Training',
}

/** { value, label } array for FormSelect components */
export const PILLAR_OPTIONS: { value: string; label: string }[] = PILLAR_TYPES.map((p) => ({
  value: p,
  label: PILLAR_LABELS[p],
}))

// ── Region constants ─────────────────────────────

export const REGION_TYPES = [
  'africa',
  'apac',
  'asia',
  'europe',
  'latin_america',
  'middle_east',
  'north_america',
  'oceania',
  'south_america',
  'worldwide',
] as const

export type RegionType = (typeof REGION_TYPES)[number]

export const REGION_LABELS: Record<RegionType, string> = {
  africa: 'Africa',
  apac: 'APAC',
  asia: 'Asia',
  europe: 'Europe',
  latin_america: 'LATAM',
  middle_east: 'Middle East',
  north_america: 'North America',
  oceania: 'Oceania',
  south_america: 'South America',
  worldwide: 'Worldwide',
}

/** { value, label } array for FormSelect components */
export const REGION_OPTIONS: { value: string; label: string }[] = REGION_TYPES.map((r) => ({
  value: r,
  label: REGION_LABELS[r],
}))
